module.exports = __webpack_public_path__ + "img/logo-sm-light.15b993e5.png";